import React from 'react';
import { CompoundOccupancy, CompoundSlotOccupancy } from '@/types/CompoundMap';

const reasons: Record<string, string> = {
  'mapping-unconfirmed':
    'This map slot does not have a confirmed complete position.',
  'mapping-missing': 'No matching position is available in this map.',
  'mapping-ambiguous': 'Multiple map slots share this position.',
  'outside-customer-scope':
    'Vehicle records for this slot are outside your current access scope.',
  'position-incomplete':
    'Vehicle records have incomplete positions; occupancy cannot be established.',
  'multiple-vehicles': 'Multiple vehicle records refer to the same slot.',
};

export const recordedStatus = (row?: CompoundSlotOccupancy) => {
  if (!row || row.status === 'unknown') return 'Unknown occupancy';
  if (row.status === 'unrecorded')
    return 'No vehicle recorded in current selection';
  if (row.status === 'conflict')
    return row.vehicles.length
      ? `Conflict — ${row.vehicles.length} recorded vehicles`
      : 'Conflicting location mapping';
  return 'Occupied — recorded vehicle';
};

export const recordedReason = (row?: CompoundSlotOccupancy) =>
  !row
    ? 'No current occupancy record is available for this slot.'
    : row.reason
      ? (reasons[row.reason] ??
        'Occupancy cannot be established for this slot.')
      : undefined;

export function RecordedVehicleDetails({
  row,
  positionSource,
}: {
  row?: CompoundSlotOccupancy;
  positionSource?: CompoundOccupancy['positionSource'];
}) {
  return (
    <div className="cc-compound__recorded-detail">
      {positionSource === 'dev-test' && (
        <strong className="cc-compound__notice">
          DEV test positions — artificially assigned for testing
        </strong>
      )}
      <strong>{recordedStatus(row)}</strong>
      {(!row || row.reason) && <span>{recordedReason(row)}</span>}
      {row?.vehicles.map((vehicle) => (
        <span key={vehicle.stockId}>
          Stock {vehicle.stockId} · VIN {vehicle.vin}
          {[vehicle.registration, vehicle.make, vehicle.model, vehicle.colour]
            .filter(Boolean)
            .map((value, index) => (
              <React.Fragment key={index}> · {value}</React.Fragment>
            ))}
        </span>
      ))}
    </div>
  );
}
